import type {MaltIllustrationName} from './malt-illustration-name';

// DAM cache buster for a file replaced in place under the same name.
// Used as query param vh=$hash
export const illustrationVersionHashes: Partial<Record<MaltIllustrationName, string>> = {
    'admin-computer--high': 'ac4e50',
    'contract-on-malt--high': 'ecea03',
    'credit-card-and-invoice--high': '3b24a7',
    'growing-plant--high': '555edf',
    'invoices--high': '94c40f',
    'profile-card-edit--high': '87fbad',
    'teamwork-dropzone--high': 'dfcf60',
    'winner-badge--high': '88dc83',
};
